import EmployeeLine from "./EmployeeLine"

export default EmployeeLine